<template>
  <div>
  <div v-if="!json.init" class="spe-txt-explain" :style="commonStyle" :ddt-area="`component_${json.floorId}`" ddt-expose="on">
    <div v-html="content" class="txt-box" :style="{ color: jdata.color, 'text-align': align(jdata.align) }" @click="click"
        :data-area="pt()"
        :data-pos="`component_${json.floorId}_文本组件.文本_点击显示弹窗`"
         data-desc="文本点击显示弹窗"
        :dd_name="`${pt()}.component_${json.floorId}_文本组件.显示弹窗_点击.弹窗显示`"
        :ddt-click="`${pt()}.component_${json.floorId}_文本组件.显示弹窗_点击.弹窗显示`"
        :ddt-pit="`显示弹窗_点击`"
        :ddt-src="`弹窗显示`"
         ddt-expose="on">
    </div>  
	<div class="text-popup" v-if="isShow && isPopup">
        <div class="popup-content">
            <div class="title">{{ popContent && popContent.title}}</div>
            <div class="main" :style="{ color: popContent.color, fontSize: popContent.fontSize, lineHeight: popContent.lineHeight, 'text-align': align(popContent.align) }" >
                <p v-for="(item, i) in popContent && popContent.contents" :key="i">{{item}}</p>
            </div>
        </div>
        <div class="popup-close" @click="clickClose"
            :data-area="pt()"
            :data-pos="`component_${json.floorId}_文本组件.弹窗关闭_点击跳转`"
             data-desc="文本点击弹窗关闭"
            :dd_name="`${pt()}.component_${json.floorId}_文本组件.弹窗关闭_点击.关闭弹窗`"
            :ddt-click="`${pt()}.component_${json.floorId}_文本组件.弹窗关闭_点击.关闭弹窗`"
            :ddt-pit="`弹窗关闭_点击`"
            :ddt-src="`关闭弹窗`"
            ddt-expose="on"><i class="iconfont">&#xe638;</i></div>
	</div>
  </div>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
export default {
  name: "spe-txt-explain",
  props: {
    json: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isShow: false,
      isPopup: false,
      popContent: {}
    }
  },
  computed: {
    jdata() {
      return this.json.data || { commonStyle: {} };
    },
    commonStyle() {
      let sty = {};
      if (this.jdata.commonStyle.backgroundType == 2) {
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
      } else if(this.jdata.commonStyle.backgroundType == 1){
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor = this.jdata.commonStyle.bgColor + ' !important'
        }else{
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor + ' !important';
        }
      }
      let font = {}
      if (this.jdata.fontSizePx) {
        font = this.getFontSizePx(this.jdata.fontSizePx)
      } else {
        font = this.getFontSize(this.jdata.fontSize)
      }
      Object.assign(sty, font)
      if (this.jdata.commonStyle.margin) {
        sty.paddingLeft = `${this.jdata.commonStyle.margin / 50}rem`
        sty.paddingRight = `${this.jdata.commonStyle.margin / 50}rem`
      }
      if (this.jdata.margin) {
        sty.paddingTop = `${this.jdata.margin / 50}rem`
        sty.paddingBottom = `${this.jdata.margin / 50}rem`
      }

      return sty;
    },
    content(){
      return this.jdata.content ? this.jdata.content.replace(/\n/g, '<br>') : ""
    },
    align() {
      return function(type) {
        switch (type) {
          case 1: return 'left';
          case 2: return 'center';
          case 3: return 'right';
        } 
      }
    }
  },
  inject: ['pt'],
  watch: {
    json: {
      handler(newVal) {
        let { data } = JSON.parse(JSON.stringify(newVal))
        if(!data) {
          return
        }
        let { popContent , showPop } = data
        if(!showPop) {
            return
        }
        this.popContent = Object.assign(popContent)  
        this.popContent.contents = popContent && popContent.content && popContent.content.split('\n')
        let font = {}
        if (popContent.fontSizePx) {
          font = this.getFontSizePx(popContent.fontSizePx)
        } else {
          font = this.getFontSize(popContent.fontSize)
        }
        this.popContent.fontSize = font.fontSize
        this.popContent.lineHeight = font.lineHeight
        this.isPopup = showPop
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    click() {
      this.isShow = true
    },
    clickClose() {
      this.isShow = false
    },
    getFontSizePx(fontSizePx) {
      let sty = {}
      if (fontSizePx) {
        sty.fontSize = `${fontSizePx / 50}rem`; 
        sty.lineHeight = `${(fontSizePx / 50) * 1.8}rem`
      }

      return sty
    },
    getFontSize(fontSize) {
      let sty = {}
      switch (fontSize) {
        case 1: 
          sty.fontSize = '.24rem'; 
          sty.lineHeight = '.42rem'
          break;
        case 2: 
          sty.fontSize = '.26rem'; 
          sty.lineHeight = '.46rem'
          break;
        case 3: 
          sty.fontSize = '.28rem'; 
          sty.lineHeight = '.48rem'
          break;
      } 
      return sty
    }
  }
}
</script>

<style lang="less" scoped>
  .spe-txt-explain{
    font-size: .26rem;
    line-height: .32rem;
    font-weight: 400;
    padding: .2rem .2rem;
    background-position: 0 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .txt-box{
      text-wrap: normal;
      color: #333;
    }

    .text-popup {
      position: fixed;
      width: 750px;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      left: 0;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9999;
      flex-direction: column;
      .popup-content {
        width: 550px;
        height: 636px;
        background: #FFFFFF;
        border-radius: 16px;
        .title {
          height: 94px;
          line-height: 94px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 34px;
          color: #141414;
          letter-spacing: 0;
          font-weight: 600;
          margin: 0px 32px;
        }
        .main {
          margin: 0px 32px 32px;
          height: 510px;
          overflow-y: auto;
        }
        .main::-webkit-scrollbar {
            display: none;
        }
      }
      .popup-close {
        margin-top: 60px;
        font-size: 80px;
        color: #FFFFFF;
      }
    }

  }

</style>
